import React, { Component } from "react";
import styled from "styled-components";
import {
  IconButton,
  Dialog,
  DialogContent
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import SlidingConfirmSection from "components/Global/SlidingConfirmSection";

const ModalTitle = styled.p`
  font-weight: normal;
  font-size: 17pt;
  margin-left: 20px;
`;

const StyledDialogIconButton = styled(IconButton)`
  && {
    position: absolute;
    top: 8px;
    right: 13px;
  }`;
export class QuoteCombineCompareAnalysisModal extends Component {
  render() {
    const { isOpen, handleClose, isRefi, isModifyDeal, hasSeniorAndMezzLoans } = this.props;

    return (
      <Dialog
        modal
        maxWidth={"md"}
        open={isOpen}
        autoDetectWindowHeight={false}
        autoScrollBodyContent={false}
        contentStyle={{ width: "600px", maxWidth: "none" }}
        onClose={handleClose}
      >
        <ModalTitle>
          Choose Analysis Method
        </ModalTitle>
        <StyledDialogIconButton onClick={handleClose}><CloseIcon id="closeIcon" style={{ fontSize: 22 }} /></StyledDialogIconButton>
        <DialogContent>

          <SlidingConfirmSection
            title="COMPARE"
            description={isModifyDeal ? "Compare modified loan details to last saved state side-by-side." : "Compare quotes of the same type side-by-side."}
            noSlide
            onConfirm={this.props.selectCompare}
            containerStyle={{ marginBottom: "20px", width: "700px" }}
          />
          {hasSeniorAndMezzLoans && !isModifyDeal &&
            <>
              <SlidingConfirmSection
                title="COMBINE"
                description="View the aggregate of one (1) senior quote and one (1) subordinate quote."
                noSlide
                onConfirm={this.props.selectCombine}
                containerStyle={{ marginBottom: "20px", width: "700px" }}
              />

              {isRefi &&
                <SlidingConfirmSection
                  title={"COMBINE \& COMPARE"}
                  description="Compare the aggregate of your existing financing with your choice of one (1) senior and one (1) subordinate quote."
                  noSlide
                  onConfirm={this.props.selectCompareAndCombine}
                  containerStyle={{ width: "700px" }}
                />}
            </>}
        </DialogContent>
      </Dialog>
    );
  }
}

export default (QuoteCombineCompareAnalysisModal);
